import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/annuity-calculator',
  component: () => import('../../routes/AnnuityCalculator.svelte'),
  card: {
    id: 'annuity-calculator',
    title: 'Annuity Calculator',
    description: 'Calculate the income payout from a fixed-period annuity. Enter your premium, interest rate, and payout term to see your payment schedule and total returns.',
    icon: 'payments',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/annuity-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Annuity Calculator – Fixed Period Annuity Payout Calculator',
    description: 'Free annuity calculator to calculate fixed-period annuity payouts. Enter your premium, annual interest rate, and payout term to see monthly income, total returns, and year-by-year payment schedule.',
  },
};

export default meta;
